(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ── Cart AJAX sync (badge + drawer sections) ── */
  function getCartSections() {
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function refreshCartSections(openDrawer) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var url = root + '?sections=' + getCartSections().join(',');
    return fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (sections) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && sections['cart-drawer']) {
          var inner = document.getElementById('CartDrawer');
          if (inner) {
            var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
            var next = parsed.getElementById('CartDrawer');
            if (next) inner.innerHTML = next.innerHTML;
            drawer.classList.remove('is-empty');
          }
        }
        /* Custom header cart icon — badge only (never wipe Lucide mark-up) */
        updateHeaderBadge(true);
        if (openDrawer && drawer) {
          if (window.ssHeaderUI && typeof window.ssHeaderUI.closeAll === 'function') {
            window.ssHeaderUI.closeAll({ cart: true });
          }
          drawer.open(document.getElementById('cart-icon-bubble'));
        }
      })
      .catch(function () { updateHeaderBadge(true); });
  }

  function updateHeaderBadge(fetchCount) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;

    function apply(count) {
      var badge = bubble.querySelector('.ss-badge, .cart-count-bubble');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'ss-badge cart-count-bubble';
          bubble.appendChild(badge);
        }
        badge.innerHTML = '<span aria-hidden="true">' + count + '</span>';
        bubble.classList.add('is-updating');
        setTimeout(function () { bubble.classList.remove('is-updating'); }, 360);
      } else if (badge) {
        badge.remove();
      }
    }

    if (!fetchCount) return;
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { apply(cart.item_count || 0); })
      .catch(function () {});
  }

  function initCartEvents() {
    document.addEventListener('cart:refresh', function (evt) {
      var open = evt.detail && evt.detail.openDrawer;
      refreshCartSections(open);
    });

    document.addEventListener('submit', function (evt) {
      var form = evt.target;
      if (!form || form.getAttribute('action') !== '/cart/add') return;
    });
  }

  /* ── Collection pills / Quick Shop — duplicate items for seamless marquee ── */
  function initPills() {
    document.querySelectorAll('[data-ss-pills]').forEach(function (viewport) {
      var track = viewport.querySelector('[data-ss-pills-track]');
      if (!track || track.dataset.ssCloned) return;
      if (prefersReducedMotion()) return;
      var children = Array.prototype.slice.call(track.children);
      if (!children.length) return;
      children.forEach(function (child) {
        var clone = child.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        track.appendChild(clone);
      });
      track.dataset.ssCloned = '1';
    });
  }

  /* ── Search UX enhancements ── */
  function initSearch() {
    document.querySelectorAll('.ss-search details-modal details').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        var input = details.querySelector('.ss-search__input');
        if (input) setTimeout(function () { input.focus(); }, 120);
      });
    });

    document.querySelectorAll('[data-ss-search-overlay]').forEach(function (overlay) {
      overlay.addEventListener('click', function () {
        var modal = overlay.closest('details-modal');
        if (modal && typeof modal.close === 'function') modal.close(false);
      });
    });
  }

  /* Account: click + Escape owned by ss-header-ui.js; CSS :focus-within covers keyboard. */
  function initAccount() {}

  function init() {
    initCartEvents();
    initPills();
    initSearch();
    initAccount();
    updateHeaderBadge(true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.ssRefreshCart = refreshCartSections;
})();
